<template lang="pug">
.loader-wrapper
  md-layout#loader(md-align='center', v-show='loading')
    md-spinner.md-accent(md-indeterminate='', :md-size='size')
  transition(
    name='fade'
    enter-active-class='animated fadeIn'
  )
    .loader-content(v-show='!loading')
      slot
</template>

<script>
  export default {
    props: {
      loading: {
        type: Boolean,
        required: true
      },
      size: {
        type: Number,
        default: 60
      }
    }
  };
</script>

<style lang="scss" scoped>
  #loader {
    padding: 1em;
  }
  .loader-wrapper {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/Loader.vue